export const OPTIONHISTORY_LIST_ATTEMPT = "OPTIONHISTORY_LIST_ATTEMPT";
export const OPTIONHISTORY_LIST_SUCCESS = "OPTIONHISTORY_LIST_SUCCESS";
export const OPTIONHISTORY_LIST_FAILED = "OPTIONHISTORY_LIST_FAILED";